"use strict";

// Elements
const startBtn = document.getElementById("start-btn");
const firstStep = document.querySelector(".first-step");
const secondStep = document.querySelector(".second-step");
const animContainer = document.querySelector(".anim #anim-placeholder");
const feedback = document.getElementById("feedback");
const sendBtn = document.getElementById("send-btn");
const userInput = document.getElementById("user-answer");
const idkBtn = document.getElementById("idk-btn");
const nextBtn = document.getElementById("next-btn");
const questionContainer = document.getElementById("question-container");
const idkContainer = document.querySelector(".idk");

// Tableau des animations + films
const animations = [
  { video: "assets/videos/coraline.mp4", film: "Coraline" },
  { video: "assets/videos/scream.mp4", film: "Scream" },
  // { video: "assets/videos/coraline-green.mp4", film: "green" },
];

let current = null;
let lastIndex = -1;
let currentVideo = null;

// Sélection aléatoire différente de la précédente
function getRandomAnimation() {
  if (animations.length === 0) return null;
  let idx;
  do {
    idx = Math.floor(Math.random() * animations.length);
  } while (idx === lastIndex && animations.length > 1);
  lastIndex = idx;
  return animations[idx];
}

// Lancer une animation
function startAnimation() {
  current = getRandomAnimation();
  if (!current) return;

  animContainer.innerHTML = `
    <video
      id="current-video"
      src="${current.video}"
      autoplay
      loop
      muted
      playsinline
      style="object-fit:cover; "
    ></video>
  `;

  currentVideo = document.getElementById("current-video");

  // Activation / désactivation du son
  let soundEnabled = false;

  // Clique -> toggle du son
  currentVideo.addEventListener("click", () => {
    soundEnabled = !soundEnabled;
    currentVideo.muted = !soundEnabled;
  });

  // Reset feedback/input
  feedback.innerText = "";
  userInput.value = "";

  questionContainer.style.display = "flex";
  idkContainer.style.display = "block";

  nextBtn.style.display = "none";
}

// Vérifier réponse
function checkAnswer() {
  const answer = userInput.value.trim();
  if (answer.toLowerCase() === current.film.toLowerCase()) {
    feedback.style.color = "green";
    feedback.innerText = "C'est exact !!";

    questionContainer.style.display = "none";
    idkContainer.style.display = "none";

    nextBtn.style.display = "inline-block";
  } else {
    feedback.style.color = "red";
    feedback.innerText = "Incorrect !! Réessaie.";
  }
  userInput.value = "";
}

// Bonne réponse
function revealAnswer() {
  feedback.style.color = "orange";
  feedback.innerText = `La réponse était : ${current.film}`;

  questionContainer.style.display = "none";
  idkContainer.style.display = "none";

  nextBtn.style.display = "inline-block";
}

// Listeners
startBtn.addEventListener("click", () => {
  firstStep.style.display = "none";
  secondStep.style.display = "block";
  startAnimation();
});

sendBtn.addEventListener("click", checkAnswer);
idkBtn.addEventListener("click", revealAnswer);
nextBtn.addEventListener("click", startAnimation);

userInput.addEventListener("keydown", (e) => {
  if (e.key === "Enter") {
    e.preventDefault();
    checkAnswer();
  }
});

// Bruit de fond canvas
const canvas = document.getElementById("noiseCanvas");
const ctx = canvas.getContext("2d");

canvas.width = window.innerWidth;
canvas.height = window.innerHeight;

function generateNoise() {
  const imageData = ctx.createImageData(canvas.width, canvas.height);
  const buffer = new Uint32Array(imageData.data.buffer);

  for (let i = 0; i < buffer.length; i++) {
    const shade = Math.random() * 80;
    buffer[i] = (255 << 24) | (shade << 16) | (shade << 8) | shade;
  }

  ctx.putImageData(imageData, 0, 0);
  requestAnimationFrame(generateNoise);
}

generateNoise();
